// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__Iod1b","selected":"Chip_selected__1h8XI"};